const body = document.querySelector("body");

export function showBodyScroll(scrollTop) {
 body.classList.remove('hide-scroll');
 window.scrollTo(0, scrollTop);
}

export function hideBodyScroll(cb) {
 const scrollTop = window.pageYOffset;
 cb(scrollTop);
 body.classList.add('hide-scroll');
}



// WEBPACK FOOTER //
// ./src/utils/htmlHelper.js